import { Fragment } from 'react';
import {
    htmlTreeDownload,
    htmlTreeNpm
} from '../assets/code-snippets/install/install'
import Snippet from '../components/Snippet/Snippet'

const Install = (props) => {

    return <Fragment>
        <div className="spacer md"></div>

        <div className="container lg" id="download">
            <p className="text lg primary border-underline-dark"><a href="#download" className="link">&#128279;</a> Using the download button from POKE-CSS home webpage </p>
            <div className="spacer sm"></div>
            <div className="row align-items-center">
                <div className="col md-III">
                    <Snippet code={htmlTreeDownload} language="treeview" />
                </div>
            </div>
            <div className="spacer sm"></div>
            <p className="text md"> Once you click the download button you'll download the latest version of POKE-CSS, will download in your computer the archived folder of this project, all you need to do is to reverse this process by extracting those files using popular software out there, like <a href="https://www.win-rar.com/start.html?&L=0" target="_blank" rel="noopener noreferrer">WinRAR</a>, the folder is archived using <span className="bold info">.rar</span> extension. </p>
            <div className="spacer sm"></div>
            <p className="text md"> If you use these files in a raw project as plain HTML, CSS & JavaScript webpages, apart of <span className="bold info">.scss</span> files, the main stylesheet file is already compiled in a minified version which can be found in root folder.</p>
            <div className="spacer sm"></div>
        </div>


        <div className="hr double medium xl primary"></div>

        <div className="container lg" id="npm-install">
            <p className="text lg primary border-underline-dark"><a href="#npm-install" className="link">&#128279;</a> Using NPM install method</p>
            <div className="spacer sm"></div>
            <div className="row align-items-center">
                <div className="col md-III">
                    <Snippet code={htmlTreeNpm} language="treeview" />
                </div>
            </div>
            <div className="spacer sm"></div>
            <p className="text md"> In order to download the latest version of POKE-CSS use the following command to download it into you project.  </p>
            <Snippet code='npm install poke-css' language="cmd" />
            <p className="text md"> To download a specific version add <span className="bold success lg">@version_number</span> after the install command, but before you do that please check npm poke-css package page to see which versions are available and what has been added to each one of them.</p>
            <p className="text md"> <a href="https://www.npmjs.com/package/poke-css" target="_blank" rel="noopener noreferrer">https://www.npmjs.com/package/poke-css</a> </p>
            <Snippet code='npm install poke-css@1.1.0' language="cmd" />
        </div>
        <div className="spacer lg"></div>
    </Fragment>
}

export default Install